// FiltersBar.jsx
import React from "react";
import FilterDropdown from "../dropdowns/filter-dropdown";
import { MaterialMenu, ColorMenu,MaterialMenuTwo } from "../dropdowns/menus";
import DimensionsMenu from "../dropdowns/dimensions-menu";
import PriceMenu from "../dropdowns/price-menu";
import { SelectedFilters } from "../dropdowns/selected-filters";

let INDUSTRY_OPTIONS = [];

let FEATURES_OPTIONS = [];

let COLLECTIONS_OPTIONS = [];

let PRODUCTS_OPTIONS = [];

let STATUS_OPTIONS = [
    { value: "new", label: "New Items" },
    { value: "inStock", label: "In Stock" },
    { value: "clearance", label: "Clearance" },
    { value: "commercialGrade", label: "Commercial Grade" }
];

class ProductFiltersBar extends React.Component {
    constructor(props) {
        super(props);

        let industryArray=[];
        if(props.industry){
            industryArray.push(props.industry);
        }
        var init = props.initialFilters || {};
        this.state = {
            priceRange: init.priceRange || {},
            industry: init.industry || industryArray,
            features: init.features || [],
            status: init.status || [],
            collections: init.collections || [],
            products: init.products || [],
            dimensions: init.dimensions || {}
        };

        this.populateOptions();
    }

    populateOptions=()=>{
        // Reset module-level OPTIONS arrays before re-populating — without this,
        // a key-bump remount of ProductFiltersBar (triggered by URL-state
        // restoration) re-runs the constructor and APPENDS duplicates.
        INDUSTRY_OPTIONS = [];
        FEATURES_OPTIONS = [];
        COLLECTIONS_OPTIONS = [];
        PRODUCTS_OPTIONS = [];
        var filters=this.props.filters;
        filters.industries.forEach((obj)=>{
            INDUSTRY_OPTIONS.push({value:obj,label:obj});
        });
        filters.features.forEach((obj)=>{
            FEATURES_OPTIONS.push({value:obj,label:obj});
        });
        filters.collections.forEach((obj)=>{
            if(obj)COLLECTIONS_OPTIONS.push({value:obj,label:obj});
        });
        filters.productTypes.forEach((obj)=>{
            if(obj) PRODUCTS_OPTIONS.push({value:obj,label:obj});
        });
    }

    toggleValueOLD = (group, value) => {
        this.setState((prev) => {
            const current = prev[group] || [];
            const exists = current.indexOf(value) !== -1;
            return {
                ...prev,
                [group]: exists
                    ? current.filter((v) => v !== value)
                    : current.concat(value),
            };
        });
    };

    toggleValue = (group, value) => {
        this.setState((prev) => {
            const current = prev[group] || [];
            const exists = current.indexOf(value) !== -1;

            const updatedGroup = exists
                ? current.filter((v) => v !== value)
                : current.concat(value);

            const nextState = {
                ...prev,
                [group]: updatedGroup,
            };

            if (typeof this.props.onFiltersChange === "function") {
                // pass the full filters object up to the parent
                this.props.onFiltersChange(nextState);
            }

            return nextState;
        });
    };

    onPriceApply = (vals) => {
        this.setState((prev) => {
            var nextState = { ...prev, priceRange: vals };
            if (typeof this.props.onFiltersChange === "function") {
                this.props.onFiltersChange(nextState);
            }
            return nextState;
        });
    };

    onDimensionsApply = (dims) => {
        this.setState((prev) => {
            var nextState = { ...prev, dimensions: dims };
            if (typeof this.props.onFiltersChange === "function") {
                this.props.onFiltersChange(nextState);
            }
            return nextState;
        });
    };

    clearGroup = (group) => {
        this.setState((prev) => ({ ...prev, [group]: [] }));
    };

    clearAll = () => {
        var cleared = {
            priceRange: {},
            industry: [],
            features: [],
            status: [],
            collections: [],
            products: [],
            dimensions: {}
        };
        this.setState(cleared, () => {
            if (typeof this.props.onClearAll === 'function') {
                this.props.onClearAll(cleared);
            } else if (typeof this.props.onFiltersChange === 'function') {
                this.props.onFiltersChange(cleared);
            }
        });
    };

    getSelectedItems() {
        const { priceRange, industry, features, status, collections, products, dimensions } = this.state;
        const chips = [];

        // Price chips
        if (priceRange) {
            var gt = priceRange.greaterThan;
            var lt = priceRange.lessThan;
            if (gt != null || lt != null) {
                var priceStr = "";
                if (gt != null && lt != null) priceStr = "$" + gt + " - $" + lt;
                else if (gt != null) priceStr = "over $" + gt;
                else priceStr = "under $" + lt;
                chips.push({
                    id: "__price",
                    group: "__price",
                    value: "price",
                    label: "Price: " + priceStr,
                });
            }
        }

        INDUSTRY_OPTIONS.forEach((opt) => {
            if (industry.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `industry:${opt.value}`,
                    group: "industry",
                    value: opt.value,
                    label: `Industry: ${opt.label}`,
                });
            }
        });

        FEATURES_OPTIONS.forEach((opt) => {
            if (features.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `features:${opt.value}`,
                    group: "features",
                    value: opt.value,
                    label: `Features: ${opt.label}`,
                });
            }
        });

        STATUS_OPTIONS.forEach((opt) => {
            if (status.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `status:${opt.value}`,
                    group: "status",
                    value: opt.value,
                    label: `Status: ${opt.label}`,
                });
            }
        });
        PRODUCTS_OPTIONS.forEach((opt) => {
            if (products.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `product:${opt.value}`,
                    group: "products",
                    value: opt.value,
                    label: `Product Type: ${opt.label}`,
                });
            }
        });
        COLLECTIONS_OPTIONS.forEach((opt) => {
            if (collections.indexOf(opt.value) !== -1) {
                chips.push({
                    id: `collection:${opt.value}`,
                    group: "collections",
                    value: opt.value,
                    label: `Collection: ${opt.label}`,
                });
            }
        });

        // Dimension chips
        var dimLabels = {
            width: "Width", height: "Height", depth: "Depth",
            armHeight: "Arm Height", seatHeight: "Seat Height", seatDepth: "Seat Depth"
        };
        if (dimensions) {
            Object.keys(dimLabels).forEach((key) => {
                var min = dimensions[key + "Min"];
                var max = dimensions[key + "Max"];
                if (min != null || max != null) {
                    var rangeStr = "";
                    if (min != null && max != null) rangeStr = min + '" - ' + max + '"';
                    else if (min != null) rangeStr = min + '"+';
                    else rangeStr = 'up to ' + max + '"';
                    chips.push({
                        id: `__dimension:${key}`,
                        group: "__dimension",
                        value: key,
                        label: `${dimLabels[key]}: ${rangeStr}`,
                    });
                }
            });
        }

        return chips;
    }

    handleRemoveChip = (chip) => {
        if (chip.group === "__price") {
            this.setState((prev) => {
                var nextState = { ...prev, priceRange: {} };
                if (typeof this.props.onFiltersChange === "function") {
                    this.props.onFiltersChange(nextState);
                }
                return nextState;
            });
            return;
        }
        if (chip.group === "__dimension") {
            this.setState((prev) => {
                var dims = { ...prev.dimensions };
                delete dims[chip.value + "Min"];
                delete dims[chip.value + "Max"];
                var nextState = { ...prev, dimensions: dims };
                if (typeof this.props.onFiltersChange === "function") {
                    this.props.onFiltersChange(nextState);
                }
                return nextState;
            });
            return;
        }
        this.toggleValue(chip.group, chip.value);
    };

    render() {
        const { industry, priceRange, features, status, collections, products, dimensions } = this.state;
        const chips = this.getSelectedItems();
        let industryCls='';
        if(INDUSTRY_OPTIONS.length<2) industryCls='hide';
        let featuresCls='';
        // Unlike Industry/Products/Collections (where a single option can't
        // narrow anything), ONE feature is a meaningful filter — e.g. a sofa
        // gallery whose only feature is "Available in Leather". Only two
        // feature strings exist catalog-wide (Casters / Leather), so the old
        // <2 gate hid the dropdown on every upholstery gallery except Dining
        // Chairs, the only one carrying both (client ticket 2026-10-02).
        if(FEATURES_OPTIONS.length<1) featuresCls='hide';
        let productsCls='';
        if(PRODUCTS_OPTIONS.length<2) productsCls='hide';
        let collectionsCls='';
        if(COLLECTIONS_OPTIONS.length<2) collectionsCls='hide';

        return (
            <div>
                {/* Top filter bar */}
                <div className="ff-filter-bar">
                    <FilterDropdown label="Industry" cls={industryCls}>
                        {({ close }) => (
                            <MaterialMenu
                                options={INDUSTRY_OPTIONS}
                                selectedValues={industry}
                                onToggle={(value) => this.toggleValue("industry", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Price" cls={!this.props.isSignedIn ? 'hide' : ''}>
                        {({ close }) => (
                            <PriceMenu
                                values={priceRange}
                                onApply={this.onPriceApply}
                                close={close}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Features" cls={featuresCls}>
                        {({ close }) => (
                            <MaterialMenu
                                options={FEATURES_OPTIONS}
                                selectedValues={features}
                                onToggle={(value) => this.toggleValue("features", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Status">
                        {({ close }) => (
                            <MaterialMenu
                                options={STATUS_OPTIONS}
                                selectedValues={status}
                                onToggle={(value) => this.toggleValue("status", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Products" cls={productsCls}>
                        {({ close }) => (
                            <MaterialMenu
                                options={PRODUCTS_OPTIONS}
                                selectedValues={products}
                                onToggle={(value) => this.toggleValue("products", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Collections" cls={collectionsCls}>
                        {({ close }) => (
                            <MaterialMenuTwo
                                options={COLLECTIONS_OPTIONS}
                                selectedValues={collections}
                                onToggle={(value) => this.toggleValue("collections", value)}
                            />
                        )}
                    </FilterDropdown>
                    <FilterDropdown label="Dimensions">
                        {({ close }) => (
                            <DimensionsMenu
                                values={dimensions}
                                onApply={this.onDimensionsApply}
                                close={close}
                            />
                        )}
                    </FilterDropdown>
                </div>

                {/* Selected filters row */}
                <SelectedFilters
                    items={chips}
                    onRemove={this.handleRemoveChip}
                    onClearAll={this.clearAll}
                />
            </div>
        );
    }
}

export default ProductFiltersBar;
